// import components
import { styled } from '@mui/material';
import Alert from '@mui/material/Alert';

export const StyledUnsavedDataContainerAlert = styled(Alert)(() => ({
  background: 'none',
  padding: 0,
  display: 'flex',
  alignItems: 'center'
}));
